import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import Wrapper from "src/components/Wrapper";
import { setActiveDialogIfCanBeShown } from "src/store/adminHtml/actions";
import {
  alertsSelector,
  activeDialogSelector,
} from "src/store/adminHtml/selector";
import { getTourOpen, getTourStepType } from "src/store/tour/selector";
import { userSetupQuestionsSelector } from "src/store/system/selector";

import Content from "./Content";

function Dispatcher() {
  const dispatch = useDispatch();
  const isTourOpen = useSelector(getTourOpen);
  const tourStepType = useSelector(getTourStepType);
  const setupQuestions = useSelector(userSetupQuestionsSelector);
  const suppressMaintenanceDialog =
    tourStepType === "analytics" && (isTourOpen || !!setupQuestions);
  const isMaintenanceActivitiesDialogOpen = useSelector(
    (state: any) =>
      activeDialogSelector(state) === "maintenance_activities_dialog"
  );

  // Opens maintenance dialog
  useEffect(() => {
    if (suppressMaintenanceDialog) return;

    const opened = dispatch(
      setActiveDialogIfCanBeShown("maintenance_activities_dialog")
    );

    if (!opened) {
      dispatch((dispatch, getState) => {
        const hasAlerts = !!alertsSelector(getState())?.length;
        if (hasAlerts) {
          dispatch(
            setActiveDialogIfCanBeShown("walk_through_notifications_icon")
          );
        }
      });
    }
  }, [dispatch, suppressMaintenanceDialog]);

  // This isn't the nicest solution, but it's the quicker one in order to fix
  // the race conditions of all these initial walkthrough / dialogs
  useEffect(() => {
    if (!isMaintenanceActivitiesDialogOpen) return;

    return () => {
      dispatch((dispatch, getState) => {
        const activeDialog = activeDialogSelector(getState());
        const isMaintenanceActivityCurrentlyOpened =
          activeDialog === "maintenance_activities_dialog";
        if (isMaintenanceActivityCurrentlyOpened) return;

        if (!isMaintenanceActivitiesDialogOpen) {
          const hasAlerts = !!alertsSelector(getState())?.length;
          if (hasAlerts) {
            dispatch(
              setActiveDialogIfCanBeShown("walk_through_notifications_icon")
            );
          }
        }
      });
    };
  }, [isMaintenanceActivitiesDialogOpen, dispatch]);

  return null;
}

function ManagementPage() {
  return (
    <Wrapper>
      <Dispatcher />
      <Content />
    </Wrapper>
  );
}

export default ManagementPage;
